import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Text } from '../../designs'

interface Props {
  title: string
  description?: ReactNode
  eyebrow?: ReactNode
  actions?: ReactNode
  className?: string
}

const AdminPageHeader = ({ title, description, eyebrow, actions, className }: Props) => {
  return (
    <header className={clsx('space-y-3', className)}>
      {eyebrow ? (
        <Text size='xs' weight={600} color='primary' className='uppercase tracking-[0.16em]'>
          {eyebrow}
        </Text>
      ) : null}

      <div className='flex flex-wrap items-start justify-between gap-3'>
        <Text variant='h2' size='3xl' weight={700} className='leading-tight'>
          {title}
        </Text>
        {actions ? <div className='flex shrink-0 items-center gap-2'>{actions}</div> : null}
      </div>

      {description ? (
        <div className='max-w-3xl border-l-2 border-primary-100 pl-4'>
          {typeof description === 'string' ? (
            <Text size='s' color='gray' className='leading-relaxed'>
              {description}
            </Text>
          ) : (
            <div className='space-y-2'>{description}</div>
          )}
        </div>
      ) : null}
    </header>
  )
}

export default AdminPageHeader
